/**
 * Arrow Up stage persistence (Bearer token = sessionId&organizationId).
 */

export async function arrowUpInitRules({
  token,
  userId,
  email,
  fullName,
  user_type,
  reportid,
  themeName,
  selectedCategory,
  defaultCat,
  playableCategories,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/arrowUpInitRules`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      email: email ?? null,
      fullName: fullName ?? null,
      user_type: user_type ?? null,
      reportid: reportid ?? null,
      themeName,
      selectedCategory,
      defaultCat,
      playableCategories,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || 'Failed to init Arrow Up stage');
  }
  if (!data.success) {
    throw new Error(data.message || 'Failed to init Arrow Up stage');
  }
  return data;
}

export async function arrowUpSaveCategory({
  token,
  userId,
  themeName,
  stageId,
  categoryUpper,
  score,
  timeSec,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/arrowUpSaveCategory`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      themeName,
      stageId,
      categoryUpper,
      score,
      timeSec,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || 'Failed to save category');
  }
  if (!data.success) {
    throw new Error(data.message || 'Failed to save category');
  }
  return data;
}
